import DatasetDetailPage from "./DatasetDetailPage";

const usStockData = {
  title: "Cryptocurrency Tracking: Prices by Day",
  description:
    "The Cryptocurrency Tracking: Prices by Day dataset delivers coverage of over 1,500 different cryptocurrencies, spanning more than five years of historical data. With daily updates, it offers a scalable and automated solution for accessing pricing metrics, streamlining data analysis and eliminating the complexities of data pipelines. Four common pricing metrics are contained in the dataset in addition to the date and name of the currency.  Crypto-Crypto transactions are captured alongside real world currency values.",
  columns: [
    { name: "Date", description: "Date of trading" },
    { name: "Name", description: "Cryptocurrency symbol pair" },
    { name: "Open", description: "Opening Price for the day" },
    { name: "High", description: "Highest traded price for the day" },
    { name: "Low", description: "Lowest traded price for the day" },
    { name: "Close", description: " Closing price for the day" },
  ],
  technicalDetails: [
    "Refresh Interval - Daily at 8:30 PM PST",
    "Pricing Interval - Daily",
    "Historical Included - Up to 10 years",
  ],
  urlSnowflake: "https://app.snowflake.com/marketplace/listing/GZTSZ1PHJ0E/openmetadata-net-cryptocurrency-tracking-prices-by-day",
  urlDatabricks: "https://databricks.com",
};

const DatasetCrypto = () => {
  return <DatasetDetailPage dataset={usStockData} />;
};

export default DatasetCrypto;
